//泰语
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: 'เงินกู้',
        Bo2: 'ช่วยค้นหาโอกาสทางธุรกิจและผลิตภัณฑ์ทางการเงิน',
        Bo3: 'กฎระเบียบเงินกู้',
        Bo4: 'กรณี',
        Bo5: 'หากชำระภายในกำหนด: อัตราดอกเบี้ยคงที่',
        Bo6: 'จะมีค่าใช้จ่ายทุกวันสำหรับจำนวนเงินที่ไม่ชำระในระหว่างระยะเวลา',
        Bo7: 'ค่าปรับ. โปรดระมัดระวังในความสามารถในการชำระคืนก่อนที่จะกู้เงิน เพื่อหลีกเลี่ยงค่าใช้จ่ายเพิ่มเติมที่ไม่จำเป็น.',
        Bo8: 'ยกเลิก',
        Bo9: 'ยืนยัน',
        Bo10: 'ชำระคืน',
        Bo11: 'หมายเหตุ: ที่อยู่สำหรับฝากเงินและที่อยู่สำหรับชำระคืนจะแตกต่างกัน ดังนั้นโปรดชำระคืนที่อยู่ที่ถูกต้องเพื่อหลีกเลี่ยงข้อผิดพลาด.',
        Bo12: 'ที่อยู่กระเป๋าเงิน:',
        Bo13: 'ปฏิเสธการเปลี่ยนแปลง',
        Bo14: 'เหตุผลในการปฏิเสธ:',
        Bo15: 'ดำเนินการแก้ไขต่อ',
        Bo16: 'ส่งสำเร็จ, ผู้ดูแลจะตรวจสอบคำขอเงินกู้ภายใน 24 ชั่วโมง โปรดระมัดระวัง',
        Bo17: 'อนุมัติ - จำนวนเงินที่ได้รับอนุญาต',
        Bo18: 'สามารถตรวจสอบได้ในบัญชีเข้ารหัสลับ',
        Bo19: 'จำนวนวันของเงินกู้',
        Bo20: 'การจ่าย',
        Bo21: 'รวมดอกเบี้ย',
        Bo22: 'การจ่ายด้วยคลิกเดียว',
        Bo23: 'ข้อมูลเงินกู้',
        Bo24: 'ชื่อธนาคาร',
        Bo25: 'หมายเลขบัญชีธนาคาร',
        Bo26: 'จำนวนเงินกู้ที่ต้องการ',
        Bo27: 'เอกสารยืนยันตัวตน',
        Bo28: 'บัตรประจำตัวประชาชนด้านหน้าและด้านหลัง',
        Bo29: 'คลิกเพื่ออัปโหลด',
        Bo30: 'ชื่อ',
        Bo31: 'หมายเลขโทรศัพท์มือถือ',
        Bo32: 'หมายเลขบัตรประจำตัวประชาชน',
        Bo33: 'ที่อยู่ถิ่นฐาน',
        Bo34: 'ที่อยู่ปัจจุบัน',
        Bo35: 'ข้อมูลการรับรองผู้ค้ำประกัน',
        Bo36: 'ชื่อผู้ค้ำประกัน',
        Bo37: 'หมายเลขติดต่อ',
        Bo38: 'ความสัมพันธ์กับลูกค้า',
        Bo39: 'ที่อยู่',
        Bo40: 'หลักฐานรายได้ (สลิปเงินเดือน, เอกสารบริษัท ฯลฯ อัปโหลด)',
        Bo41: 'หลักฐานรายได้',
        Bo42: 'หลักฐานความเป็นเจ้าของ (เอกสารสิทธิ์ที่ดิน, เอกสารรถยนต์, เอกสารเงินฝาก ฯลฯ)',
        Bo43: 'หลักฐานความเป็นเจ้าของ',
        Bo44: 'เอกสารอื่น ๆ',
        Bo45: 'ส่งเอกสารที่เกี่ยวข้องกับเงินกู้',
        Bo46: 'อัปโหลดบัตรประจำตัวประชาชนด้านหน้าและด้านหลัง',
        Bo47: 'อัปโหลดหลักฐานรายได้',
        Bo48: 'อัปโหลดหลักฐานความเป็นเจ้าของ',
        Bo49: 'ผู้ใช้เงินกู้',
        Bo50: 'รายการชำระคืน',
        Bo51: 'การกู้เงินสกุลเงินมีความเสี่ยง ผลลัพธ์สุดท้ายขึ้นอยู่กับการตรวจสอบจริง',
        Bo52: 'ทำไมถึงเลือกกู้เงินสกุลเงิน?',
        Bo53: 'การอนุมัติอย่างรวดเร็ว ค่าธรรมเนียมที่โปร่งใส',
        Bo54: 'กรุณาเลือกธนาคารที่คุณต้องการกู้เงินสกุลเงิน',
        Bo55: 'สินเชื่อโดยตรงจากธนาคาร ไม่ต้องมีหลักประกัน',
        Bo56: 'ประวัติศาสตร์',
        Bo57: 'คำที่ระลึก',
        Bo58: 'คำที่ระลึกสามารถใช้สำหรับเข้าสู่แอปพลิเคชัน',
        Bo59: 'สร้าง',
        Bo60: 'ดู',
        Bo61: 'คัดลอก',
        Bo62: 'เสียใจมาก',
        Bo63: 'อย่าหมดหวัง ปรับกลยุทธ์และลองอีกครั้ง!',
        Bo64: 'ขอแสดงความยินดี',
        Bo65: 'เป็นสัญญาณที่ดี! รักษาสถานะนี้ไว้และบรรลุความสำเร็จต่อไป',
        Bo66: 'สั่งซื้อต่อไป',
        Bo67: 'เพื่อความปลอดภัยของเงินทุนของคุณ โปรดใส่ใจเป็นพิเศษกับข้อควรระวังในการชำระเงินดังต่อไปนี้:',
        Bo68: '1. ใช้ที่อยู่ชำระเงินอย่างเป็นทางการที่ให้ไว้โดยแพลตฟอร์มเท่านั้น: ที่อยู่ชำระเงินใดๆ ที่ได้จากแหล่งที่ไม่ใช่ช่องทางอย่างเป็นทางการของแพลตฟอร์มจะเป็นโมฆะ',
        Bo69: '2. ระวังการหลอกลวง: หากมีคนติดต่อคุณส่วนตัวและให้ที่อยู่ชำระเงินที่เรียกว่า อย่าหลงเชื่อได้ง่ายๆ',
        Bo70: '3. รับผิดชอบต่อความปลอดภัยของเงินทุน: หากเกิดการสูญเสียเงินทุนเนื่องจากการใช้ที่อยู่ชำระเงินที่ผิดพลาด แพลตฟอร์มจะไม่รับผิดชอบและอาจดำเนินการทางกฎหมายตามความเกี่ยวข้องตามกฎหมาย',
        Bo71: 'โปรดอยู่ในความตื่นตัวและตรวจสอบให้แน่ใจว่าการดำเนินการชำระเงินจะดำเนินการผ่านช่องทางอย่างเป็นทางการเพื่อปกป้องความปลอดภัยทรัพย์สินของคุณได้อย่างมีประสิทธิภาพ!',
        Bo72: 'ประกาศด้านความปลอดภัย',
        Bo73: 'เข้าใจแล้ว',
        Bo74: 'บัญชีปัจจุบันของคุณเป็นบัญชีเสมือนและเงินทั้งหมดในบัญชีนั้นใช้สำหรับการซื้อขายแบบจำลองเท่านั้นและไม่สามารถใช้ในการถอนเงินจริงได้ โปรดระมัดระวังและป้องกันความเสี่ยงเกี่ยวข้อง!',


    },
    other: {
        back_order: 'เคล็ดลับการถอนตัว',
        review_failed: "รีวิวไม่ผ่าน",
        try_again: "โปรดลองอีกครั้ง"
    },
    withdraw: {
        // memoTip: '请填写memo',
        // memoWar: '在充币页面查找复制'
    },
    Purchase: {
        Pu1: 'ซื้อ',
        Pu2: 'เลือกการชำระเงิน',
        Pu3: 'เลือกวิธีการชำระเงิน',
        Pu4: 'ยืนยันการสั่งซื้อ',
        Pu5: 'มาถึง',
        Pu6: 'ยอดคงเหลือ',
        Pu7: 'โปรดป้อนปริมาณการซื้อ',
        Pu8: 'กรุณาใส่จำนวนเงิน',
        Pu9: 'กรุณาใส่ปริมาณการขาย',
        Pu10: 'ทั้งหมด',
        Pu11: 'ขั้นต่ำจะไม่น้อยกว่า',
        Pu12: 'สูงสุดต้องไม่มากกว่า',
        Pu13: 'ราคาอ้างอิง',
        Pu14: 'อัตราค่าบริการ',
        Pu15: 'ซื้อเลย',
        Pu16: 'ขายตอนนี้',
        Pu17: 'ซื้อ',
        Pu18: 'ขาย',
        Pu19: 'เลือกวิธีการชำระเงิน',
        Pu20: 'วิธีการชำระเงิน',
        Pu21: 'เพิ่มวิธีการชำระเงิน',
        Pu22: 'เพิ่ม',
        Pu23: 'ชื่อผู้ใช้',
        Pu24: 'หมายเลขบัตรธนาคาร',
        Pu25: 'IFSC code',
        Pu26: 'หมายเลขโทรศัพท์มือถือ',
        Pu27: 'ยืนยัน',
        Pu28: 'ยืนยันการสั่งซื้อ',
        Pu29: 'เย้',
        Pu30: 'คุณถอนเงินสำเร็จ',
        Pu31: 'สถานะ',
        Pu32: 'เสร็จสิ้น',
        Pu33: 'จำนวนเงินที่ได้รับ',
        Pu34: 'ซื้อ',
        Pu35: 'ขาย',
        Pu36: 'ชื่อสกุลเงิน',
        Pu37: 'ยอดรวมธุรกรรม',
        Pu38: 'ปริมาณ',
        Pu39: 'ราคา',
        Pu40: 'สถานะ',
        Pu41: 'เวลา',
        Pu42: 'ราคา',
        Pu43: 'ความสำเร็จ',
        Pu44: 'ล้มเหลว',
        Pu45: 'ในการประมวลผล',
        Pu46: 'หมดอายุ',
        Pu47: 'ปฏิเสธ',
        Pu48: 'ถึง',
        Pu49: 'เว็บไซต์ทางการ',
        Pu50: 'กระดาษสีขาว',
        Pu51: 'บทนำ',
        Pu52: 'ลิงค์เว็บไซต์อย่างเป็นทางการ',
    },
    nhome: {
        Nh1: 'หนึ่งในการแลกเปลี่ยน cryptocurrency ที่ใหญ่ที่สุดในโลกคือแพลตฟอร์มที่เชื่อถือได้ของคุณ',
        Nh2: 'ผู้ใช้ที่ลงทะเบียนแพลตฟอร์มมากกว่าหนึ่งล้านรายที่มีปริมาณการซื้อขายมากกว่า 1,000,000,000 USDT ต่อวันเข้าร่วมกับเราในขณะนี้เพื่อติดตามผู้เชี่ยวชาญด้านการซื้อขายสำหรับการซื้อขายการลงทุน',
        Nh3: 'ปริมาณการซื้อขาย',
        Nh4: 'ผู้ใช้',
        Nh5: 'บริการผลิตภัณฑ์ที่หลากหลาย',
        Nh6: 'เลือกบริการอื่น ๆ และสำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุด',
        Nh7: 'การซื้อขายสัญญา',
        Nh8: 'สปอตเทรด',
        Nh9: 'การซื้อขายตัวเลือก',
        Nh10: 'การซื้อขายสกุลเงินฝรั่งเศส',
        Nh11: 'รายการสกุลเงินที่มีสภาพคล่องสูงสุดและอัตราแขวนบิลต่ำสุดมีประสิทธิภาพและมีคุณภาพใหม่และมีสภาพคล่องที่ยอดเยี่ยม ',
        Nh12: 'บริการการซื้อขายที่ให้บริการหลายร้อยสกุลเงินที่มีคุณภาพเทียบเท่ามีความปลอดภัยและเชื่อถือได้และมีอัตราการซื้อขายต่ำสุดในตลาด',
        Nh13: 'จำนวนผู้เข้าร่วมมากที่สุด, การเล่นที่ยุติธรรมและอัตราต่อรองสูง',
        Nh14: 'One Click Fast Buy ให้คุณมีระบบการซื้อขายแบบเรียลไทม์ที่มีประสิทธิภาพและสะดวกสบาย การเข้าออกของเงินทุนของคุณสามารถถอนเป็นวินาที ',
        Nh15: 'สกุลเงินดิจิตอลยอดนิยม',
        Nh16: 'ดูเพิ่มเติม',
        Nh17: 'จุดแข็งของเรา',
        Nh18: 'มีระบบควบคุมอากาศที่ปลอดภัยชั้นนำของโลก',
        Nh19: 'การป้องกันสินทรัพย์ของผู้ใช้ทุกรอบ',
        Nh20: '---- เป็นแพลตฟอร์มที่เชื่อถือได้ของคุณ ',
        Nh21: 'โหมดจัดเก็บข้อมูลออฟไลน์',
        Nh22: 'การเข้ารหัสแบบหลายปัจจัย',
        Nh23: '24 * 7 วันตรวจสอบแพลตฟอร์ม ',
        Nh24: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำ',
        Nh25: '- บริการการซื้อขายสินทรัพย์ดิจิทัลและการจัดการสินทรัพย์ที่หลากหลายเพื่อตอบสนองความต้องการในการซื้อขายที่หลากหลาย',
        Nh26: 'เริ่มเทรดได้ทุกที่ทุกเวลา',
        Nh27: 'รองรับทั้งระบบ IOS และ Android',
        Nh28: 'สแกน QR Code เพื่อดาวน์โหลด',
        Nh29: 'รายการกำไร',
        Nh30: 'รายชื่อขาลง',
        Nh31: 'รายการซื้อขาย',
        Nu32: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก',
        Nu33: '- บริการซื้อขายสินทรัพย์ดิจิทัลและการบริหารสินทรัพย์ที่หลากหลายเพื่อตอบสนองความต้องการในการซื้อขายที่หลากหลาย',
        Nu34: 'เริ่มการซื้อขายและสัมผัสประสบการณ์การเดินทาง cryptocurrency ที่ดีที่สุด',
        Nu35: 'ความยาวไม่น้อยกว่า 5 ',
        Nu36: 'ซื้อด่วน',
        Nu37: 'ซื้อเหรียญ',
        Nu38: '1. ปากกาเดี่ยว 300w - 1 พันล้าน IDR',
        Nu39: '2. หลังจากได้รับบัญชีการชำระเงินแล้วโปรดทำการโอนเงินให้เสร็จสิ้นภายในเวลาที่กำหนดซึ่งเกินเวลาที่กำหนดโปรดติดต่อฝ่ายบริการลูกค้าที่นี่เพื่อยืนยันว่าคำสั่งซื้อถูกต้อง ',
        Nu40: '3. หลังจากโอนเงินเรียบร้อยแล้ว กรุณาระบุบัญชีซื้อขายหลักทรัพย์หรือ UID ของบัญชี พร้อมภาพหน้าจอการโอนเงินโดยละเอียด พร้อมเอกสารส่วนตัวที่ถูกต้อง',
        Nu41: 'คลิ๊กที่รู้'
    },
    common: {
        logins: 'เข้าสู่ระบบ......',
        login: 'เข้าสู่ระบบ',
        register: 'ลงทะเบียน',
        close: "ปิด",
        ok: "ระบุ",
        fillComplete: "กรุณากรอกข้อมูลให้ครบถ้วน",
        logout: 'ออกจากระบบ',
        tip: 'เคล็ดลับอบอุ่น',
        logintip: 'กรุณาเข้าสู่ระบบก่อน',
        more: "มากขึ้น",
        please: "ก่อนโปรด",
        pleaseselect: "โปรดเลือก",
        searchplaceholder: "ป้อนชื่อสกุลเงินเพื่อค้นหา",
    },
    header: {
        index: 'บ้าน',
        exchange: 'การซื้อขายเหรียญ',
        option: "สัญญาตัวเลือก",
        service: 'ประกาศ',
        usercenter: "ศูนย์ส่วนบุคคล",
        helpcenter: "ศูนย์ช่วยเหลือ",
        assetmanage: "การจัดการเงิน",
        trademanage: "การจัดการการซื้อขาย",
        lab: "ico launch",
        invite: "พันธมิตรโปรโมชั่น",
        innovationmanage: "การจัดการนวัตกรรม",
        swap1: "สัญญาถาวร",
    },
    service: {
        high: "ราคาสูงสุด 24 ชั่วโมง",
        low: "ราคาที่ดีที่สุด 24 ชั่วโมง",
        CUSTOM: 'เลือกเอง',
        NewPrice: 'ราคาล่าสุด',
        ExchangeNum: 'จำนวนการซื้อขาย',
        Change: '24h ขึ้นและลง',
        Exchange: 'ไปแลกเปลี่ยน',
    },
    swapAssets: {
        Br1: 'ซื้อคืน',
        Br2: 'การเสนอราคาซื้อ',
        Br3: 'โอนเข้าบัญชีสัญญา',
        Br4: 'โอนออกจากบัญชีสัญญา',
        Br5: 'กำไรและขาดทุนของสัญญาถาวร',
        Br6: 'สิ้นสุด',
        Br7: 'บัญชีสัญญา (มาตรฐาน U)',
        Br8: 'ยอดคงเหลือในกระเป๋าสตางค์',
        Br9: 'ราคาปัจจุบัน',
        Br10: 'ไคโด',
        Br11: 'เปิดว่าง',
        Br12: 'ซ่อนสัญญาอื่น ๆ',
        Br13: 'การปิดเพียงคลิกเดียว',
        Br14: 'ถอนคำสั่งทั้งหมด',
        Br15: 'การแก้ไขยอดคงเหลือของสัญญาถาวร',
    },
    exchange: {
        buyamounttip: 'โปรดป้อนปริมาณการซื้อ',
        buyamounttipwarning: 'ปริมาณการซื้อไม่สามารถสูงกว่า',
        wholehog: 'ขายได้มากที่สุด',
        coin: 'สกุลเงิน',
        symbol: "คู่เทรด",
        lastprice: 'ราคาล่าสุด',
        daychange: '24h ขึ้นและลง',
        do_favorite: 'คอลเลกชัน',
        cancel_favorite: 'ยกเลิกคอลเลกชัน',
        type: "ประเภท",
        dealamount: "จำนวนการซื้อขาย",
        limited_price: 'ราคาจำกัด',
        market_price: 'ราคาตลาด',
        canuse: 'ใช้ได้',
        buyprice: 'ราคาซื้อ',
        buynum: 'ปริมาณการซื้อ',
        amount: 'ปริมาณการซื้อขาย',
        buyin: 'ซื้อ',
        buytip: 'ซื้อในราคาที่ดีที่สุดในตลาด',
        sellprice: 'ราคาขาย',
        sellnum: 'ปริมาณการขาย',
        sellout: 'ขาย',
        selltip: 'ขายในราคาที่ดีที่สุดในตลาด',
        curdelegation: 'ค่าคอมมิชชั่นปัจจุบัน',
        hisdelegation: 'ประวัติการมอบอำนาจ',
        num: 'ปริมาณ',
        price: 'ราคา',
        direction: 'ทิศทาง',
        time: 'เวลา',
        total: 'สะสม',
        action: 'การดำเนินงาน',
        undo: 'ถอนคำสั่ง',
        done: 'ปิด',
        status: 'สถานะ',
        finished: 'เสร็จแล้ว',
        canceled: 'ยกเลิก',
        buyamountip: 'กรุณาใส่ปริมาณการซื้อ',
        buyamountipwarning: 'ปริมาณการซื้อไม่สามารถสูงกว่า',
        success: 'ส่งเสร็จ',
        pricetip: 'กรุณาใส่ปริมาณการซื้อขาย',
        pricetipwarning: 'ปริมาณการซื้อขายต้องไม่สูงกว่า',
        sellamounttip: 'กรุณาใส่ปริมาณการขาย',
        sellpricetip: 'กรุณากรอกราคาขาย',
        undotip: 'ยืนยันการถอนหรือไม่? ',
        cancelsuccess: "การถอนเงินสำเร็จ!",
        marketprice: 'ราคาตลาด',
        depth: "แผนภาพความลึก",
        dateTimeDay: "วัน",
        moredetail: "รายละเอียดเพิ่มเติม"

        // recharge: '充币',
        // fees_rate: '费率',
        // balance: '资产',
        // or: '或',
        // starttrade: '开始交易',
        // disablesellout: "禁止市价卖出",
        // disablebuyin: "禁止市价买入",
        // realtransaction: '实时成交',
        // stall: '档位',
        // high: '高',
        // low: '低',
        // vol: '24H量',
        // buy: '买入',
        // sell: '卖出',
        // traded: '已成交',
        // delegationnum: '委托量',
        // parted: "部分成交",
        // tip: '提示',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetipwarning: '卖出价格不能高于',
        // market: '市场',
        // favorite: '收藏',
        // dateTimeHour: "时",
        // dateTimeMinutes: "分",
        // dateTimeSeconds: "秒",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",

    },
    swap: {
        Sw1: 'เพิ่มมาร์จิ้น',
        Sw2: 'ลดมาร์จิ้น',
        Sw3: 'เพิ่ม',
        Sw4: 'ลด',
        Sw5: 'มาร์จิ้น',
        Sw6: 'ได้ถึง ',
        Sw7: 'คือ ราคา Qiangping หลังจาก',
        Sw8: 'คือ ทวีคูณเลเวอเรจหลังจาก',
        Sw10: 'เพิ่มมาร์จิ้นสัญญา',
        Sw11: 'ลดมาร์จิ้นสัญญา',
        Sw12: 'คำบรรยาย',
        Spsl1: 'เวลาเรียกใช้งานจริง',
        Spsl2: 'จำนวนทริกเกอร์จริง',
        Spsl3: 'ทิศทางทริกเกอร์จริง',
        Spsl4: 'ราคาทริกเกอร์จริง',
        contract: "สัญญา",
        swapindex: "ตลอดไป",
        lastprice: 'ราคาล่าสุด',
        daychange: '24H ขึ้นและลง',
        vol: 'ปริมาณ 24H',
        limited_price: 'ราคาจำกัด',
        market_price: 'ค่าคอมมิชชั่นราคาตลาด',
        spot_price: 'หยุดการทำกำไรและหยุดขาดทุน',
        or: 'หรือ ',
        curdelegation: 'ค่าคอมมิชชั่นปัจจุบัน',
        hisdelegation: 'พันธกิจประวัติศาสตร์',
        num: 'ปริมาณ',
        time: 'เวลา',
        undo: 'ถอนคำสั่ง',
        success: 'ส่งเสร็จ',
        cancelsuccess: "การถอนเงินสำเร็จ!",
        marketprice: 'ราคาตลาด',
        open: "เปิดตำแหน่ง",
        close: "ปิด",
        myswapaccount: "บัญชีสัญญาของฉัน",
        accountmode: "โหมดบัญชี",
        accountmargin: "สัญญาทวีคูณ",
        accountquanyi: "ส่วนของบัญชีทั้งหมด",
        profitandloss: "กำไรและขาดทุนที่ไม่เกิดขึ้น",
        principalAmount: "มาร์จิ้นที่มีอยู่",
        positionAmount: "มาร์จิ้นตำแหน่ง",
        frozenAmount: "มาร์จิ้นแช่แข็ง",
        principalRate: "การใช้เงิน",
        zijinhuazhuan: "การโอนเงิน",
        up: " หลาย",
        down: "ว่างเปล่า",
        canup: "เปิดได้หลาย",
        candown: "เปิด",
        cancloseup: "สถานะว่างสามารถแบน",
        canclosedown: "หลายถังสามารถแบน",
        openup: "ซื้อหลาย",
        opendown: "เปิดขาย",
        closeup: "ซื้อแบน",
        closedown: "ขาย Pindo",
        currentposition: "สถานะที่เปิดอยู่ในปัจจุบัน",
        marginMode1: "ตามสถานะ",
        marginMode2: "เต็มถัง",
        modifyMarginModeTitle: "แก้ไขโหมดบัญชี",
        modifyLeverage: "ปรับทวีคูณสัญญา",
        shareNumber: "จาง",
        entrustprice: "ราคาหลัก",
        triggleprice: "ราคาทริกเกอร์",
        openvolume: "ปริมาณการเปิดตำแหน่ง",
        closevolume: "ปริมาณการปิด",
        triggleplaceholder: "ราคาเริ่มต้นเป็นราคาตลาด",
        marketpriceplaceholder: "ปิดด้วยราคาที่ดีที่สุดในตลาด",
        levmaxtip: "ทวีคูณของสัญญาไม่สามารถสูงกว่าทวีคูณสูงสุด",
        levmintip: "ทวีคูณของสัญญาต้องไม่น้อยกว่าทวีคูณขั้นต่ำ",
        marginModeSuccessTip: "ความสำเร็จในการปรับเปลี่ยนรูปแบบบัญชีสัญญา",
        noenoughbalance: "มาร์จิ้นในบัญชีไม่เพียงพอ",
        pleaseinputopenvolume: "ปริมาณการเปิดตำแหน่งต้องมากกว่า 0",
        pleaseinputcorrectopenvolume: "กรุณาใส่จำนวนที่ถูกต้องของตำแหน่งที่เปิด",
        pleaseinputrightentrustprice: "กรุณาใส่ราคาค่าคอมมิชชั่นที่ถูกต้อง",
        noenoughposition: "ตำแหน่งที่ปิดได้ไม่เพียงพอ",
        pleaseinputclosevolume: "จำนวนการปิดต้องมากกว่า 0",
        pleaseinputcorrectclosevolume: "กรุณาใส่จำนวนตำแหน่งที่ถูกต้อง",
        pos_Pl: "รายได้",
        pos_Ratio: "ผลตอบแทน",
        pos_pos: "ปริมาณการเปิดตำแหน่ง",
        pos_openPrice: "เปิดสถานะเฉลี่ย",
        pos_mRatio: "อัตรามาร์จิ้น",
        ent_entrustType: "เปิด/ปิดสถานะ",
        ent_direction: "ทิศทาง",
        ent_type: "ประเภทการมอบหมาย",
        ent_trigglePrice: "ราคาทริกเกอร์",
        ent_entrustPrice: "ราคาหลัก",
        ent_tradedPrice: "ราคาซื้อขาย",
        ent_margin: "มาร์จิ้น",
        ent_volume: "จำนวนค่าคอมมิชชั่น",
        ent_status1: "ในการมอบหมาย",
        ent_status2: "ยกเลิก",
        ent_status3: "การมอบหมายล้มเหลว",
        ent_status4: "ความสำเร็จในการมอบหมาย",
        ent_pl: "ชำระกำไรและขาดทุน",
        ent_fee: "ค่าธรรมเนียมการจัดการ",
        triggerpriceshouldbigger: "ราคาทริกเกอร์ต้องมากกว่า 0",
        buyamounttip: 'โปรดป้อนปริมาณการซื้อ',
        buyamounttipwarning: 'ปริมาณการซื้อไม่สามารถสูงกว่า',

        // ent_statusblast: "爆仓",
        // ent_status: "委托状态",
        // pos_cmRatio: "维持保证金率",
        // pos_long: "多头",
        // pos_short: "空头",
        // pos_leverage: "合约倍数",
        // pos_margin: "当前保证金",
        // pos_canClose: "可平量",
        // moredetail: "更多详情",
        // assetsdetail: "资金明细",
        // latestdeal: "最新交易",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",
        // depth: "深度图",
        // pricetip: '请输入交易额',
        // pricetipwarning: '交易额不能高于',
        // sellamounttip: '请输入卖出量',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetip: '请输入卖出价格',
        // sellpricetipwarning: '卖出价格不能高于',
        // undotip: '是否确认撤单？',
        // delegationnum: '委托量',
        // done: '已成交',
        // status: '状态',
        // finished: '已完成',
        // canceled: '已取消',
        // parted: "部分成交",
        // tip: '提示',

        // stall: '档位',
        // total: '累计',
        // traded: '已成交',
        // action: '操作',
        // coin: '币种',
        // symbol: "交易对",
        // volume: "成交量",
        // market: '市场',
        // favorite: '收藏',
        // do_favorite: '已收藏',
        // cancel_favorite: '取消收藏',
        // type: "类型",
        // dealamount: "成交金额",
        // high: '高',
        // low: '低',
        // buy: '买入',
        // sell: '卖出',
        // fees_rate: '费率',
        // balance: '资产',
        // starttrade: '开始交易',
        // canuse: '可用',
        // recharge: '充币',
        // buyprice: '买入价',
        // buynum: '买入量',
        // amount: '交易额',
        // buyin: '买入',
        // disablebuyin: "禁止市价买入",
        // buytip: '以市场上最优价格买入',
        // sellprice: '卖出价',
        // sellnum: '卖出量',
        // sellout: '卖出',
        // disablesellout: "禁止市价卖出",
        // selltip: '以市场上最优价格卖出',
        // price: '价格',
        // direction: '方向',
        // realtransaction: '实时成交',
    },
    subscribe: {
        Su1: 'หน้ารายละเอียด',
        Su2: 'การเสนอราคา',
        Su3: 'การเสนอราคาเหรียญใหม่',
        Su4: 'ที่จะเริ่มต้น',
        Su5: 'อยู่ระหว่างดำเนินการ',
        Su6: 'จะประกาศ',
        Su7: 'ระยะทาง',
        Su8: 'เริ่มต้น',
        Su9: 'ราคาเสนอขาย',
        Su10: 'อัตรากำไรและขาดทุนโดยประมาณ',
        Su11: 'เวลาเริ่มต้น',
        Su12: 'เวลาประกาศ',
        Su13: 'รายละเอียด',
        Su14: 'การเสนอราคา',
        Su15: 'บันทึกการซื้อ',
        Su16: 'ชื่อสกุลเงิน',
        Su17: 'ราคาเสนอขาย',
        Su18: 'ราคาเสนอขาย',
        Su19: 'จำนวนชนะการเสนอราคา',
        Su20: 'จำนวนเงินคืน',
        Su21: 'เวลา',
        Su22: 'สถานะ',
        Su23: 'เวลา',
        Su24: 'จำนวนเงินที่เสนอราคา',
        Su25: 'สกุลเงินที่เสนอราคา',
        Su26: 'ราคาเสนอขาย',
        Su27: 'กำไรและขาดทุนโดยประมาณ',
        Su28: 'เพดานการเสนอราคา',
        Su29: 'เวลาเริ่มต้นการเสนอราคา',
        Su30: 'เวลาสิ้นสุดการเสนอราคา',
        Su31: 'เวลาประกาศผล',
        Su32: 'เวลาโดยประมาณ',
        Su33: 'จำนวนเงินที่เสนอราคา',
        Su34: 'สกุลเงิน',
        Su35: 'จำนวนเงินที่เสนอราคา',
        Su36: 'เวลาเสนอซื้อ',
        Su37: 'สถานะ',
        Su38: 'จะประกาศ',
        Su39: 'ประกาศ',
        Su40: 'ข้อมูลโครงการ',
        Su41: 'ยอดคงเหลือ',
        Su42: 'สั่งซื้อเลย',
        Su43: 'ทั้งหมด',
        Su44: 'รหัสผ่านการชำระเงิน',
    },
    option: {
        minute: 'นาที',
        enter: 'กรุณากรอก',
        buyup: "กระทิง",
        buydown: "หมี",
        closeprice: "ราคาปิด",
        balancenotenough: "ยอดคงเหลือไม่เพียงพอ!",
        or1: 'ราคาล่าสุด',
        or2: 'เวลาเดิมพัน',
        or3: 'จำนวนเงินเดิมพัน',
        or4: 'สกุลเงินเดิมพัน',
        or5: 'จำนวนเงินอื่น ๆ',
        or6: 'ราคาปัจจุบันคือราคาดำเนินการ',
        or7: 'การซื้อขายย้อนหลัง',
        or8: 'อัตราต่อรอง',
        or9: 'โบนัส',
        or10: 'บันทึกการซื้อขาย',

        // title: "期权合约",
        // buyupreward: "买涨总额",
        // buydownreward: "买跌总额",
        // quantity: "开仓金额",
        // myamount: "我的开仓",
        // history: "往期结果",
        // seriers: "第",
        // period: "期",
        // currentoption: "本期预测周期",
        // openprice: "开盘价",
        // currentprice: "当前价",
        // openprice1: "开盘价格",
        // opentime: "开盘时间",
        // closetime: "收盘时间",
        // progress: "预测进度",
        // loginFirst: "请先登录!",
        // selectAmount: "请选择投注数量",
        // betsuccess: "恭喜你！投注成功！",
        // noopening: "暂无待期权合约",
        // col_createTime: "创建时间",
        // col_direction: "预测方向",
        // col_result: "预测结果",
        // col_optionNo: "合约期数",
        // col_betAmount: "开仓金额",
        // col_rewardAmount: "奖金数量",
        // col_fee: "开仓手续费",
        // col_winfee: "抽水",
        // win: "成功",
        // lose: "失败",
        // wait: "进行中",
        // avaliablebalance: "可用余额",
        // login: "请先登录",
        // kline: "实时行情",
    },
    activity: {
        endtime: "เวลาสิ้นสุด",
    },
    uc: {
        login: {
            noaccount: 'ไม่มีเลขที่บัญชี?',
            register: 'ลงทะเบียน',
            login: 'เข้าสู่ระบบ',
            pwdtip: 'กรุณาใส่รหัสผ่าน',
            forget: 'ลืมรหัสผ่าน?',
            loginvalidate: 'กรุณาใส่หมายเลขบัญชี',
            success: 'ล็อกอินสำเร็จ',
            goregister: "ลงทะเบียนตอนนี้",
            // getlostpwd: "忘记密码"
            // pwdvalidate1: '请输入密码',
            // pwdvalidate2: '密码长度不能少于6位',
            // validatecodeload: '正在加载验证码',
            // validatemsg: '请先完成验证',
            // welcomelogin: '欢迎登录',
            // usertip: '请输入邮箱',
        },
        forget: {
            title: "กลับรหัสผ่าน",
            sendcode: 'ส่งรหัสยืนยัน',
            save: 'ส่ง',
            mtelno: 'รับรองโทรศัพท์มือถือ',
            memail: 'การรับรองกล่องจดหมาย',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // newpwd: '请输入新密码',
            // confirmpwd: '请再次确认密码',
            // pwdvalidate1: '请输入确认密码',
            // pwdvalidate2: '两次密码输入不一致!',
            // resettelpwd: '重置手机密码',
            // resetemailpwd: '重置邮箱密码',
            // newpwdtip: '请输入新密码',
            // pwdvalidate3: '密码长度不能少于6位',
            // telno: '手机号',
            // smscode: '请输入验证码',
            // teltip: '请输入手机号',
            // smscodetip: '请输入短信验证码',
            // email: '邮箱',
            // emailcode: '邮箱验证码',
            // emailtip: '请输入邮箱',
            // emailcodetip: '请输入邮箱验证码',
            // resetpwdsuccess: '重置密码成功',
            // smswarn: '请注意查收短信',
        },
        finance: {
            fi1: 'ซ่อนสินทรัพย์ขนาดเล็ก',
            personalassets: 'บัญชีเหรียญ',
            swapassets: 'บัญชีถาวร',
            billdetail: 'การไหลของสินทรัพย์',

            // center: '财务中心',
            // tradetail: '交易挖矿',
            // paydividends: '持币分红',
            // invitingmining: '邀请挖矿奖励',
            // charge: '充币',
            // pickup: '提币',
            money: {
                M1: 'จำนวนรับ',
                M2: 'จำนวนโอนออก',
                M3: 'อัตราแลกเปลี่ยน',
                cointype: 'ชื่อสกุลเงิน',
                balance: 'สินทรัพย์ที่มีอยู่',
                frozen: 'สินทรัพย์แช่แข็ง',
                operate: 'การดำเนินงาน',
                charge: 'ชาร์จ',
                pickup: 'หยิบเหรียญ',
                onkeytrans: "หนึ่งคลิกเปิด",
                Resetsuccess: 'ประสบความสำเร็จ',
                needreleased: "สินทรัพย์ที่จะปล่อย",
                totalassets: "การรวมสินทรัพย์",

                // getaddress: '获取地址',
                // match: '配对',
                // matchtip1: '可配对GCX的数量',
                // matchtip2: '请输入配对数量',
                // matcherr1: '请输入有效的数量!',
                // matcherr2: '超出最大配对数量!',
                // matchsuccess: '配对成功!',
            },
            swap: {
                currencyaccount: "บัญชีเหรียญ",
                profitandloss: "กำไรและขาดทุนที่ไม่เกิดขึ้น",
                transfor: "การโอนเงิน",
                inputtransferamount: "จำนวนรอบ",
                swaptype: 'บัญชีสัญญา',
                avaamount: "วงเงินหมุนเวียน",
                pleaseselectwallet: "กรุณาเลือกโอนเข้า/ออกบัญชีก่อน",
                pleaseinputamount: "กรุณาใส่จำนวนรอบ",
                oktransfer: "ยืนยันการเดินทาง"
                // totalassets: "账户权益折合：",
                // swap: " 永续账户",
                // swapassets: "账户权益",
                // avabalance: "可用保证金",
                // usebalance: "已用保证金",
                // frozenbalance: "冻结保证金",
                // all: "全部划转",
                // swapaccount: "永续合约账户",
                // clickchange: "点击切换划转方向",
            },
            record: {
                operatetype: 'ประเภทการทำงาน',
                charge: 'เติมเงิน',
                pickup: 'ถอนเงิน',
                exchange: 'การซื้อขายเหรียญ',
                otcbuy: 'ซื้อเงินฝรั่งเศส',
                otcsell: 'ขายเหรียญฝรั่งเศส',
                handrecharge: 'การเติมเงินเทียม',
                chargetime: 'เวลาเทรด',
                type: 'ประเภท',
                fee: 'ค่าธรรมเนียมการจัดการ',
                revenue: 'ประเภทรายรับและรายจ่าย',
                symbol: 'สกุลเงิน',
                num: 'ปริมาณ',
                status: 'สถานะ',
                Finish: 'เสร็จแล้ว',
                quickExchange: "แฟลชไดรฟ์",
                contractfee: "ค่าธรรมเนียมการจัดการสัญญาถาวร",
                optionfail: "การคาดการณ์สัญญาล้มเหลว",
                optionreward: "โบนัสสัญญาคาดการณ์",
                other: "อื่น ๆ"
                // search: '搜索',
                // transaccount: '转账',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // match: '配对',
                // activitybuy: "活动兑换",
                // ctcbuy: "CTC买入",
                // ctcsell: "CTC卖出",
                // redout: "发红包",
                // redin: "领红包",
                // shouldfee: '应付手续费',
                // re1: '入账',
                // re2: '出账',
                // discountfee: '抵扣手续费',
                // realfee: '实付手续费',
                // activitybuy: "活动兑换",
                // ctcbuy: "C2C买入",
                // ctcsell: "C2C卖出",
                // currentRate: "当前兑换比率",
                // from: "从",
                // inputexchangeamount: "输入闪兑数量",
                // inputexchangepasswd: "输入交易密码",
                // chooseTransCoinUnit: "选择转化币种",
                // inputTransAmount: "输入转化数量",
                // predictAmount: "预计可兑数量",
                // qamount: "闪兑数量",
                // qrate: "兑换比例",
                // qexamount: "兑换数量",
                // withdrawcodein: "提币码充币",
                // withdrawcodeout: "提币码提币",
                // contractprofit: "永续合约盈利",
                // contractloss: "永续合约亏损",
                // optionfee: "预测合约手续费",
                // Please: '请选择搜素日期范围',
                // start_end: '起止时间',
                // to: '至',
            },

            trade: {
                start_end: 'เวลาเริ่มต้นและหยุด',
                search: 'ค้นหา',
                type: 'ประเภท',
                symbol: 'คู่เทรด',
                direction: 'ทิศทางการเทรด',
                buy: "ซื้อ",
                sell: "ขาย",
                limit: "จำกัด",
                market: "ราคาตลาด",
                clear: "เงื่อนไขที่ว่างเปล่า",
                // account_date: '到帐时间',
                // to: '至',
                // operatetype: '操作类型',
                // charge: '充值',
                // pickup: '提现',
                // transaccount: '转账',
                // exchange: '币币交易',
                // otcbuy: '法币买入',
                // otcsell: '法币卖出',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // handrecharge: '人工充值',
                // match: '配对',
                // chargetime: '订单生成时间',
                // fee: '挖矿手续费返还(BHB)',
                // num: '数量',
                // status: '状态',
                // finish: '已完成',
                // transactionTime: '交易时间',
                // price: '价格',
                // entrustment: '委托量',
                // havedeal: '已成交',
                // poundageAmount: '手续费',
                // exchangeOrderId: "订单ID",
                // mineAmount: "挖币数量 (BHB)",
                // turnover: "成交金额"
            },

            recharge: {
                symbol: 'สกุลเงิน',
                address: 'ที่อยู่ชาร์จ',
                qrcode: 'รหัส QR',
                msgtop: 'ที่อยู่นี้สามารถเติมเงินได้เฉพาะสินทรัพย์',
                msg1: 'อย่าเติมเงินสินทรัพย์ที่ไม่ใช่สกุลเงินไปยังที่อยู่ข้างต้นมิฉะนั้นจะไม่สามารถเรียกคืนได้',
                msg2: 'หลังจากที่คุณเติมเงินไปยังที่อยู่ข้างต้นคุณจะต้องได้รับการยืนยันจากโหนดเครือข่าย blockchain ทั้งหมดและเครือข่ายหลัก blockchain ทั่วไป 3 ครั้งจะได้รับการยืนยันในบัญชี',
                msg3: 'เติมเงินขั้นต่ำ:',
                msg3_1: ', การเติมเงินน้อยกว่าขั้นต่ำจะไม่ขึ้นบัญชี',
                msg4: 'ที่อยู่เติมเงินของคุณจะไม่เปลี่ยนแปลงบ่อยและสามารถทำซ้ำการเติมเงิน; ในกรณีที่มีการเปลี่ยนแปลงเราจะพยายามแจ้งให้คุณทราบผ่านทางประกาศของเว็บไซต์หรือทางไปรษณีย์ ',
                msg5: 'ให้แน่ใจว่าได้ยืนยันความปลอดภัยของคอมพิวเตอร์และเบราว์เซอร์ของคุณจากการปลอมแปลงหรือการรั่วไหลของข้อมูล',
                record: 'บันทึกการเติมเงิน',
                copysuccess: 'คัดลอกสำเร็จ!',
                time: 'เวลาเข้าบัญชี',
                amount: 'จำนวนการเติมเงิน',
                gettingaddress: "รับที่อยู่เติมเงินโปรดรอสักครู่ ...",
                getaddress: "รับที่อยู่เติมเงิน",

                // memotips: "充值时请按要求输入此Memo，否则会丢失资产。",
                // withdrawrecharge: "提币码充值",
                // coderechargetip: "请输入提币码",
                // rechargesuccess: "恭喜！提币码充值成功！",
                // rechargeconfirm: "充值确认",
                // status: "状态"
                // copyerr: '复制失败！请手动复制',
                // qrcodeaddress: '充值地址二维码',
                // copy: '复制',
                // recharge: '充币',
            },
            withdraw: {
                pickup: 'หยิบเหรียญ',
                symbol: 'สกุลเงิน',
                address: 'ที่อยู่รับเหรียญ',
                num: 'จำนวนการยก',
                fee: 'ค่าธรรมเนียมการจัดการ',
                arriamount: 'จำนวนบัญชี',
                record: 'บันทึกการถอนเงิน',
                symboltip: 'กรุณาเลือกสกุลเงิน',
                time: 'เวลาถอนเงิน',
                status: 'สถานะ',
                status_1: 'ในการตรวจสอบ',
                status_2: 'ในการโอนเงิน',
                status_3: 'ล้มเหลว',
                status_4: 'ความสำเร็จ',
                St5: 'ประเมินความเท่าเทียมกันที่แข็งแกร่ง',
                St6: 'สินทรัพย์รวม = ยอดคงเหลือในกระเป๋าสตางค์ + ยังไม่บรรลุผล',
                St7: 'กำไรและขาดทุนที่ยังไม่เกิดขึ้น = กำไรและขาดทุนที่ยังไม่เกิดขึ้นที่คำนวณโดยราคาล่าสุดในสัญญาที่เปิดอยู่ทั้งหมด',
                St8: 'ยอดคงเหลือในกระเป๋าสตางค์ = โอนเข้า - ออก + ได้รับกำไรและขาดทุน',
                St9: 'ถูกปฏิเสธ',
                เพิ่ม: 'เพิ่ม',
                ลบ: 'ลบ',
                txid: "TxId",
                wi1: 'เครือข่าย',
                wi2: 'ใบรับรองความปลอดภัย',
                wi3: 'จำนวนบัญชี',
                wi4: 'ไปยังที่อยู่บัญชี',
                wi5: 'เครือข่ายหยิบเหรียญ',
                wi6: 'ยอดถอนเงิน',
                wi7: 'ค่าธรรมเนียมเครือข่าย',
                wi8: 'โปรดตรวจสอบให้แน่ใจว่าคุณได้ป้อนที่อยู่การรับเงินที่ถูกต้องและเครือข่ายการรับเงินที่คุณเลือกตรงกับที่อยู่',
                wi9: 'ไม่สามารถยกเลิกได้หลังจากสร้างคำสั่งซื้อ ',
                wi10: 'ดำเนินการต่อ',
                wi11: 'รหัสผ่านกองทุน',
                wi12: 'รหัสยืนยันโทรศัพท์มือถือ',
                wi13: 'ส่งการตรวจสอบ',
                wi14: 'รหัสยืนยันกล่องจดหมาย',
                wi15: 'ส่งการตรวจสอบ',
                wi16: 'ส่ง',
                // addressmanager: '提币地址管理',
                // withdrawbycode: '提币码提币',
                // withdrawcode: '提币码',
                // avabalance: '可用余额',
                // msg1: '提币数量低于',
                // msg2: '时自动到账，否则需要人工审核',
                // increase: '提升额度',
                // tip1: '最多输入',
                // tip11: '位小数,最小值为',
                // tip2: '最大值为',
                // numtip1: '输入提币数量',
                // range: '范围',
                // msg3: '最小提币数量为',
                // msg4: '币',
                // msg5: '为保障资金安全，当您账户安全策略变更、密码修改、使用新地址提币，我们会对提币进行人工审核，请耐心等待工作人员电话或邮件联系',
                // msg6: '请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
                // addresstip: '请填入地址',
                // numtip2: '请填写正确提币数量，最小值为',
                // numtip3: '提币数量不得小于手续费',
                // amounttip: '请输入提币数量',
                // feetip1: '手续费最小值为',
                // feetip2: '最大值为',
                // remark: '备注',
                // addresslist: '地址列表',
                // safevalidate: '安全验证',
                // telno: '手机号码',
                // smscode: '手机验证码',
                // second: '秒',
                // clickget: '点击获取',
                // email: '邮箱',
                // emailcode: '邮箱验证码',
                // save: '保 存',
                // telerr: '手机号不正确',
                // emailerr: '邮箱不正确',
                // codeerr: '验证码不正确',
                // remarktip: '请输入备注',
                // savemsg1: '保存失败!',
                // savemsg2: '保存成功!',
                // operate: '操作',
                // fundpwdtip: '请输入资金密码',
                // click: '点击',
                // filtrate: '可筛选',
                // generateCode: "生成提币码",
                // withdrawcodelist: "提币码列表",
                // withdrawcodestatus: "状态",
                // submit: "提交",
                // generatecodesuccess: "提现码生成成功",
            }
        },
        member: {
            usercenter: "ศูนย์ส่วนบุคคล",
            account: "การจัดการบัญชี",
            assets: "การจัดการเงิน",
            exchange: "การจัดการธุรกรรม",
            curdelegate: "คอมมิชชั่นปัจจุบัน",
            hisdelegate: "มอบหมายทางประวัติศาสตร์",
            // securitycenter: '安全中心',
            // securitysetting: '安全设置',
            // accountsetting: '收款方式',
            // otc: "OTC管理"
        },
        regist: {
            Res1: 'ชื่อผู้ใช้ไม่สามารถว่างเปล่าประกอบด้วยตัวพิมพ์ใหญ่และตัวเลข, จะต้องมีตัวอักษร',
            username: 'ชื่อผู้ใช้',
            smscode: 'รหัสยืนยัน',
            sendcode: 'ส่งรหัสยืนยัน',
            pwd: 'รหัสผ่านเข้าสู่ระบบ',
            repwd: 'ยืนยันรหัสผ่าน',
            agreement: 'ฉันอ่านและเห็นด้วย',
            userprotocol: 'ข้อตกลงผู้ใช้',
            regist: 'ลงทะเบียน',
            teltip: 'กรุณาใส่หมายเลขโทรศัพท์มือถือ',
            telerr: 'รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้องโปรดป้อนใหม่',
            emailtip: 'โปรดป้อนกล่องจดหมาย',
            emailerr: 'รูปแบบกล่องจดหมายไม่ถูกต้องโปรดป้อนใหม่',
            confirmpwdtip: 'กรุณากรอกรหัสผ่านยืนยัน',
            confirmpwderr: 'ป้อนรหัสผ่านสองครั้งไม่สอดคล้องกัน!',
            pwdtip: 'กรุณาใส่รหัสผ่านเข้าสู่ระบบ',
            pwdmsg: 'รหัสผ่านต้องมีความยาวไม่น้อยกว่า 6 หลัก',
            telno: 'หมายเลขโทรศัพท์มือถือ',
            email: 'ที่อยู่อีเมล',
            agreementtip: 'กรุณาคลิกตกลง',
            promotion: 'รหัสเชิญ',
            emailregist: 'ลงทะเบียนกล่องจดหมาย',
            usernametip: 'กรุณาใส่ชื่อผู้ใช้',
            // telregist: '手机注册',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // country: '国家',
            // resendcode: '重新发送(',
            // confrimpwd: '确认密码',
            // usernamemsg: '用户名长度不能少于3位,多于15位',
            // countrytip: '请选择国家',
            // smscodetip: '请输入短信验证码',
            // modaltitle: '请校验',
            // china: '中国',
            // singapore: '新加坡',
            // korea: '韩国',
            // japan: '日本',
            // thailand: '泰国',
            // russia: '俄罗斯',
            // uk: '英国',
            // vietnam: '越南',
            // india: '印度',
            // italy: '意大利',
            // hk: '香港',
            // malaysia: '马来西亚',
            // taiwan: '台湾省',
            // turkey: '土耳其',
            // germany: '德国',
            // france: '法国',
            // spain: '西班牙',
            // us: '美国',
        },
        safe: {
            Ad1: 'กรุณาอัพโหลดบัตรประกันสังคม ใบขับขี่ หรือหนังสือเดินทาง',
            Ad2: 'อัปโหลดไฟล์ใดไฟล์หนึ่งก่อนที่จะส่ง',
            Ad3: 'ชื่อเต็ม',
            Ad4: 'ที่อยู่ติดต่อ',
            Ad5: 'ถ่ายทอดสด',
            Ad6: 'My Live',
            Ad7: 'เพิ่มล้มเหลว, สามารถเพิ่มได้สูงสุด 3',
            safelevel_low: 'ระดับความปลอดภัย: ต่ำ',
            safelevel_high: 'ระดับความปลอดภัย: สูง',
            safelevel_medium: 'ระดับความปลอดภัย: ปานกลาง',
            bind: 'ผูก',
            binded: 'ผูกพัน',
            binding: 'ในการตรวจสอบ',
            bindretry: 'ลองอีกครั้ง',
            verifypass: "ได้รับการรับรอง",
            verified: 'รับรองชื่อจริง',
            notverified: "ไม่ได้รับการรับรอง",
            verifiedtip: 'เพื่อความปลอดภัยของบัญชีของคุณโปรดดำเนินการซื้อขายหลังจากการรับรองชื่อจริง!',
            save: 'บันทึก',
            reset: 'รีเซ็ต',
            email: 'กล่องจดหมาย',
            bindemail: 'กล่องจดหมายผูก',
            loginpwd: 'รหัสผ่านเข้าสู่ระบบ',
            emailcode: 'รหัสยืนยันกล่องจดหมาย',
            clickget: 'คลิกเพื่อรับ',
            second: 'วินาที',
            phone: 'โทรศัพท์มือถือ',
            bindphone: 'ผูกโทรศัพท์',
            phonecode: 'รหัสยืนยันโทรศัพท์มือถือ',
            logintip: 'ใช้เมื่อเข้าสู่ระบบแพลตฟอร์ม',
            edit: 'แก้ไข',
            oldpwd: 'รหัสผ่านเข้าสู่ระบบเดิม',
            newpwd: 'รหัสผ่านเข้าสู่ระบบใหม่',
            confirmnewpwd: 'ยืนยันรหัสผ่านใหม่',
            fundpwd: 'รหัสผ่านกองทุน',
            fundtip: 'ตรวจสอบเงินทุนก่อนเมื่อมีการเคลื่อนไหวของเงินในบัญชี',
            set: 'การตั้งค่า',
            confirmpwd: 'ยืนยันรหัสผ่าน',
            oldfundpwd: 'รหัสผ่านกองทุนดั้งเดิม',
            newfundpwd: 'รหัสผ่านกองทุนใหม่',
            newpwdmsg1: 'โปรดป้อนรหัสผ่านเข้าสู่ระบบใหม่ไม่น้อยกว่า 6 หลัก',
            newpwdmsg2: 'รหัสผ่านเข้าสู่ระบบใหม่ไม่สอดคล้องกัน',
            pwdmsg1: 'กรุณาใส่รหัสผ่านไม่น้อยกว่า 6 หลัก',
            pwdmsg2: 'รหัสผ่านไม่สอดคล้องกัน',
            emailtip: 'กรุณาใส่หมายเลขกล่องจดหมาย',
            codetip: 'โปรดป้อนรหัสยืนยัน',
            realnametip: 'กรุณากรอกชื่อจริง',
            idcardtip: 'กรุณากรอกหมายเลขบัตรประชาชน',
            upload_negativetip: 'กรุณาอัพโหลดรูปด้านหลังบัตรประชาชน',
            upload_handtip: 'กรุณาอัพโหลดบัตรประชาชน',
            save_success: 'บันทึกความสำเร็จ!',
            save_failure: 'บันทึกล้มเหลว!',
            idcard_verifymsg1: "1, รองรับรูปแบบ JPG, PNG, ไฟล์น้อยกว่า 8M; ข้อมูลบนเอกสาร, มองเห็นได้ชัดเจน, ไม่อนุญาตให้มีการปรับเปลี่ยนใด ๆ และการปกปิด, ต้องสามารถมองเห็นหมายเลขเอกสารและชื่อได้อย่างชัดเจน",
            idcard_verifymsg2: "2, ภาพถ่ายจะต้องได้รับการยกเว้นจากมงกุฎ, แนะนำให้ไม่แต่งหน้า, ใบหน้าของผู้ถือเอกสารมีความชัดเจนและเรียนรู้ได้อย่างสมบูรณ์แสดงแขน",
            idcard_verifymsg3: "3, ต้องใช้ทั้งเอกสารมือถือและการเขียนคำโฆษณาด้วยลายมือ (ชื่อ + วันที่สมัคร) ' การกระทำทั้งหมดของฉันที่เว็บไซต์นี้ดำเนินการโดยตัวเองและทราบถึงความเสี่ยงที่เกี่ยวข้องและยินดีที่จะรับผลทางกฎหมายทั้งหมดของบัญชีนี้' "
            // telnotip: '请输入手机号',
            // oldpwdtip: '请输入原密码',
            // bindphonetip: '请先绑定手机!',
            // resetfundpwd: '重置资金密码',
            // upload_positivetip: '请上传身份证正面照',
            // binderr: '失败',
            // realname: '真实姓名',
            // nickname: '昵称',
            // size: '上传图片大小不能超过5M',
            // idcard: '身份证号',
            // upload: '点击上传',
            // upload_positive: '身份证正面照',
            // upload_negative: '身份证反面照',
            // upload_hand: '手持身份证与个人签名照',
        },
        otcorder: {
            money: 'จำนวนเงิน',
        },
        extension: {
            currrecharge: 'การซื้อขายปัจจุบัน',
        },
        promotion: {
            exchange: "แลกทันที",

        },
        // mining: {
        //     title: "我的矿机列表",
        //     empty: "暂无矿机",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本矿机产能可通过邀请好友获得提升，每邀请一人兑换矿机，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "产出币种",
        //     miningPeriod: "产出周期",
        //     miningDays: "挖矿时间",
        //     miningedDays: "已挖时间",
        //     miningDaysProfit: "基础产能",
        //     miningCurrentDaysProfit: "实际产能",
        //     status0: "待部署",
        //     status1: "已部署",
        //     status2: "已结束"
        // },
        // locked: {
        //     title: "我的锁仓列表",
        //     empty: "暂无锁仓",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本锁仓产能可通过邀请好友获得提升，每邀请一人参与锁仓，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "释放币种",
        //     miningPeriod: "释放周期",
        //     miningDays: "总释放周期",
        //     miningedDays: "已释放周期",
        //     miningDaysProfit: "基础释放",
        //     miningCurrentDaysProfit: "实际释放",
        //     status0: "待释放",
        //     status1: "释放中",
        //     status2: "已结束",
        //     totallocked: "总锁仓"
        // },
    },
    cms: {
        noticecenter: 'ศูนย์ประกาศ',
        notice: 'ประกาศ',
        servicecenter: 'ศูนย์บริการลูกค้า',
        aboutus: 'เกี่ยวกับเรา',
        features: "คุณสมบัติของแพลตฟอร์ม",
        contactus: "ติดต่อเรา",
        nextnotice: 'ถัดไป',
        prevnotice: "ก่อนหน้า",
        notexist: "ประกาศที่คุณเข้าชมไม่มีอยู่หรือถูกลบ!",
        otherhelp: "บทความภายในกลุ่มนี้",
        scanforshare: "กวาดเพื่อแบ่งปัน",
        download: "ดาวน์โหลดตอนนี้",
        downloadslogan: "- แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลทั่วโลก"
        // newshelp: '新手帮助',
        // appdownload: 'APP下载',
        // onlineservice: '在线客服',
        // faq: '常见问题',
        // exchangerule: '交易规则',
        // about: '关于',
        // joinus: '加入我们',
        // useprotocol: '使用协议',
        // feenote: '资费说明',
        // merchantprocotol: '商家协议',
        // noticelist: '公告列表',
    },
    description: {
        title1: 'ความปลอดภัยระดับการเงิน',
        title2: 'การชาร์จอย่างรวดเร็ว',
        title3: 'บริการระดับโลก',
        title4: 'สินทรัพย์ที่เลือกอย่างเคร่งครัด',
        message1: 'ระบบควบคุมลมทางการเงินและระบบป้องกันการโจรกรรมทุกรอบ, กระเป๋าสตางค์ร้อนและเย็น, ระบบป้ายหลายระบบรับประกันความปลอดภัยของเงิน',
        message2: 'การถอนเงินเติมเงินเร็วที่สุด 3 นาที, รีวิวออนไลน์ 24 ชั่วโมง, ปกป้องลูกค้าไม่ให้พลาดโอกาสในการลงทุนที่ดีที่สุด',
        message3: 'ครอบคลุมเครือข่ายบริการทางธุรกิจทั่วโลก, ช่วยให้คุณลงทุนในสินทรัพย์การเข้ารหัสลับทั่วโลก, ซื้อขายกับผู้ใช้ทั่วโลก',
        message4: 'เลือกอย่างเคร่งครัดรายการการเข้ารหัสลับพรีเมี่ยมกรองรายการที่มีความเสี่ยงสูงมาก 80% สำหรับคุณ',
        aboutdesc2: "แพลตฟอร์มมีสถาปัตยกรรมการซื้อขายในระดับการเงินระดับมืออาชีพและมีเครื่องมือการซื้อขายการจับคู่หน่วยความจำพร้อมกันสูงที่พัฒนาขึ้นเองและแพลตฟอร์มใช้ระบบกระเป๋าเงินเติมเงินเย็นเต็มรูปแบบ + ลายเซ็นหลายลายเซ็น + ระบบการโจมตี DDOS ที่มีการป้องกันสูงเพื่อรับประกันความปลอดภัยของสินทรัพย์ของลูกค้า",
        aboutdesc3: "เพื่อให้ลูกค้าเข้าใจโอกาสในการลงทุนได้ดียิ่งขึ้นฝ่ายบริการลูกค้าได้ใช้การจัดการแบบแบนภายในแผนกบริการลูกค้าได้จัดตั้งกลไกการตอบสนองการบริการที่รวดเร็วผู้จัดการฝ่ายบริการลูกค้าสินทรัพย์ออนไลน์ตลอดทั้งปี 7 * 24H ให้บริการลูกค้าด้วยการเติมเงินสินทรัพย์และบริการอื่น ๆ รับประกันว่าลูกค้าจะเสร็จสิ้นการเติมสินทรัพย์ภายใน 25 นาที",
        aboutdesc4: "คัดกรองโครงการที่มีคุณภาพอย่างเคร่งครัดและให้บริการดูแลสินทรัพย์ที่ปลอดภัยและมั่นคง ยึดมั่นในแนวคิด ซื่อสัตย์ยุติธรรมกระตือรือร้นเปิดกว้าง และมุ่งมั่นที่จะสร้างการแลกเปลี่ยนที่ปลอดภัยเชื่อถือได้มีประสิทธิภาพและเป็นมิตรสำหรับผู้ใช้",
        aboutdesc5: "แม้ว่าตอนนี้สินทรัพย์ดิจิทัลจะอยู่ในวงเล็ก ๆ แต่เราเชื่อว่าสินทรัพย์ประเภทนี้ที่ทุกคนสามารถควบคุมได้อย่างเต็มที่จะได้รับความนิยมในอนาคตอย่างแน่นอนขอให้ทุกคนร่วมมือกันและรอคอย!",
        support: "การสนับสนุนทางเทคนิค",
        report: "คำแนะนำในการร้องเรียน",
        service: "การบริการลูกค้า",
        apply: "แอปพลิเคชัน Upper Coin",
        coop: "ความร่วมมือทางธุรกิจ",
        community: "ชุมชน",
        wechat: "wechat",
        addwechat: "เพิ่ม bmate601 เป็นเพื่อน WeChat, เข้าสู่ชุมชนสวัสดิการ WeChat",
        weibo: "Weibo",
        Twitter: "ทวิตเตอร์",
        biyong: "สำหรับเหรียญ",
        telegram: "โทรเลข",
        medium: "Medium",
        reddit: "Reddit",
        // scanqrcode: "扫描二维码，下载APP",

    },
    footer: {
        notice: 'ประกาศแพลตฟอร์ม',
        gsmc: 'การแลกเปลี่ยนสินทรัพย์ดิจิทัลคุณภาพระดับโลก',
        gsjj: 'เกี่ยวกับ',
        gywm: 'เกี่ยวกับเรา',
        jrwm: 'เข้าร่วมกับเรา',
        lxwm: 'ติดต่อเรา',
        bzzx: 'ศูนย์ช่วยเหลือ',
        fwtk: 'ข้อตกลงผู้ใช้',
        fltk: 'รายละเอียดภาษี',
        xszn: "คู่มือสำหรับมือใหม่",
        cjwt: "คำถามที่พบบ่อย",
        mztk: "ข้อสงวนสิทธิ์",
        ystk: "ข้อกำหนดความเป็นส่วนตัว",
        tkxy: "ข้อตกลงเงื่อนไข",
        gybzb: "เกี่ยวกับ BZB",
        kfyx: "กล่องจดหมายบริการลูกค้า",
        swhz: "ความร่วมมือทางธุรกิจ",
        sbsq: "แอปพลิเคชัน Upper Coin",
        jyzn: "คู่มือการซื้อขาย",
        bzzl: "ข้อมูลสกุลเงิน",
        tsjb: "ร้องเรียนแจ้งเบาะแส",
        apidoc: "อินเทอร์เฟซ API",


        // wechatkefu: "微信客服",
        // wechat: "微信客服",
        // yqlj: '友情链接',
        // bah: '沪ICP备13026899号-3',
        // changjian: '常见问题',
        // shiyong: '使用协议',
        // feilv: '费率说明',
        // lianxi: '联系邮箱',
        // biyong: '币用',
        // xsrm: '新手教程',
        // czzn: '充值指南',
        // ptsm: '平台说明',
        // fysm: '交易规则',
    },
    index: {
        max: 'สูงสุด',
        download_code: 'สแกนรหัส QR ดาวน์โหลดแอปรับของขวัญต้อนรับ'
    },
    home: {
        login: {
            title: 'เปิดการซื้อขายเหรียญ',
            desc: 'รองรับ 500+ เหรียญและเครื่องมือการซื้อขายที่หลากหลาย',
            btnText: 'ไปเทรด'
        },
        unlogin: {
            title: 'เริ่มต้นการเดินทางของคุณไปยังสกุลเงินดิจิตอล',
            desc: 'ลงทะเบียนรับสิทธิประโยชน์ BIG GIFT PACK',
            placinfo: 'โทรศัพท์มือถือ / กล่องจดหมาย',
            btnText: 'ลงทะเบียน'
        },
        WelfareCenter: 'ศูนย์สวัสดิการ',
        Welcome_ceremony: 'ปฐมนิเทศ',
        Airdrop: 'ต้อง AirDrop',
        DailyGain: 'DailyGain',
        AirdropGift: 'AirDrop',
        financial_management: 'การเงินที่ต้องการ · ',
        Zhoude: 'โจวโจวต้อง',
        height_is: 'สูงถึง',
        Happiness: 'ห้าฟูคาร์นิวัล·',
        Monthly: 'ดวงจันทร์ต้อง',
        CarveUp: 'แบ่ง',

        download: {
            transactions_anytime: 'ทุกที่ทุกเวลา เปิดดีล',
            scan_code: 'สแกนโค้ดดาวน์โหลด',
            download_more: 'ดาวน์โหลดเพิ่มเติม'
        },
        brand: {
            digital_platform: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำ',
            rich_digital: 'บริการการซื้อขายสินทรัพย์ดิจิทัลและการจัดการสินทรัพย์ที่หลากหลายเพื่อตอบสนองความต้องการในการซื้อขายที่หลากหลาย',
            High_quality_digital: 'สินทรัพย์ดิจิทัลคุณภาพ',
            Turnover: 'ปริมาณ',
            safety_risk: 'ระบบควบคุมลมนิรภัยชั้นนำของโลก',
            multi_factor: 'วิธีการจัดเก็บแบบออฟไลน์, วิธีการเข้ารหัสแบบหลายปัจจัย, การตรวจสอบแพลตฟอร์มตลอด 7 วัน 24 ชั่วโมงตลอดทั้งปี, การป้องกันความปลอดภัยของสินทรัพย์ของผู้ใช้ในทุกด้าน ',
            Security_reserve: 'เงินสำรองเพื่อความปลอดภัย',
            accident: '9 ปี 0 อุบัติเหตุ',
            safetyrisk: 'การควบคุมความปลอดภัยลมด้านบน',
            choice_trusted: 'ตัวเลือกความไว้วางใจจากผู้ใช้นับล้าน',
            transaction_service: 'การจัดตั้งศูนย์บริการธุรกรรมท้องถิ่นในหลายประเทศทั่วโลกเพื่อสร้างวงกลม blockchain ที่มีรูปแบบธุรกิจหลายอย่าง',
            ten_thousand: 'หมื่น',
            User_preference: 'ผู้ใช้ต้องการ',
            Countries_covered: 'ประเทศที่ครอบคลุม',

        },
        trading: {
            digital_currency: 'เริ่มต้นการเดินทางของคุณไปยังสกุลเงินดิจิตอล',
            register: 'ลงทะเบียน',
            login: 'เข้าสู่ระบบ',
            currency_transaction: 'เปิดการซื้อขาย Coin',
            to_trade: 'ไปเทรด'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/th/index.js